import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { forkJoin } from 'rxjs';
import { BranchHttpService } from '../http/branch-http.service';
import { LocationHttpService } from '../http/location-http.service';

@Injectable({
    providedIn: 'root',
})
export class LocationListHttpResolverService implements Resolve<any> {
    constructor(private locationHttpService: LocationHttpService) {}
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return this.locationHttpService.getAllLocations();
    }
}

@Injectable({
    providedIn: 'root',
})
export class LocationEditHttpResolverService implements Resolve<any> {
    constructor(private locationHttpService: LocationHttpService, private branchHttpService: BranchHttpService) {}
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const getLocationById = this.locationHttpService.getLocationById(route.params.id);
        const getAllBranches = this.branchHttpService.getAllBranches();
        return forkJoin([getLocationById, getAllBranches]);
    }
}

@Injectable({
    providedIn: 'root',
})
export class LocationNewHttpResolverService implements Resolve<any> {
    constructor(private branchHttpService: BranchHttpService) {}
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return this.branchHttpService.getAllBranches();
    }
}
